import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { IProfile } from '@appShared/interfaces/[Interface-based]/profile.interface';
import { AppFacade } from '@appShared/services/app.facade';
import { NavMenuComponent } from '@app/components';

@Component({
  selector: 'app-shell',
   templateUrl: './shell.component.html',
   imports: [NavMenuComponent, RouterOutlet]
})
export class ShellComponent {
  userProfile$: Observable<IProfile>;
  title = 'Southwestern Family of Companies - Company Stock Plan';
  currentYear = new Date().getFullYear();

  constructor(appFacade: AppFacade) {
    this.userProfile$ = appFacade.userProfile$;
  }
}
